const isLocal = process.env.NODE_ENV === "development";

export const SERVER_URL = isLocal
  ? "http://localhost:8081"
  : "https://nmcprofessionals.org.uk";
export const DOCUMENTS_URL = isLocal
  ? "http://localhost:8081/uploads/"
  : "https://nmcprofessionals.org.uk/uploads/";
export const GET_ADDRESS_URL = "https://api.getAddress.io/";
